import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: true,
    moduleDetails: '',
    moduleError: '',

    componentDetails: '',
    componentError: '',

    roleDetails: '',
    roleError: '',

    featureDetails: '',
    featureError: '',

    featureComponentDetails: '',
    featureComponentError: ''

};

export default function younoteAdminSecuritySetupReducer(state = initState, action) {
    switch (action.type) {
        case actions.MODULE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.MODULE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                moduleDetails: action.payload,
            };
        }
        case actions.MODULE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                moduleError: action.message,
            };
        }

        case actions.COMPONENT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.COMPONENT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                componentDetails: action.payload,
            };
        }
        case actions.COMPONENT_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                componentError: action.message,
            };
        }


        case actions.ROLE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.ROLE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                roleDetails: action.payload,
            };
        }
        case actions.ROLE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                roleError: action.message,
            };
        }

        case actions.FEATURE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.FEATURE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                featureDetails: action.payload,
            };
        }
        case actions.FEATURE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                featureError: action.message,
            };
        }

        case actions.FEATURE_COMPONENT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.FEATURE_COMPONENT_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: false,
                featureComponentDetails: action.payload,
            };
        }
        case actions.FEATURE_COMPONENT_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                featureComponentError: action.message,
            };
        }

        case actions.CLEAR_SECURITY_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_SECURITY_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: true,
                featurePermisionLoader: true,
            };
        }

        default:
            return state;
    }
}